import { render, staticRenderFns } from "./devGuideMenu.vue?vue&type=template&id=6635956d&scoped=true&"
import script from "./devGuideMenu.vue?vue&type=script&lang=js&"
export * from "./devGuideMenu.vue?vue&type=script&lang=js&"
import style0 from "./devGuideMenu.vue?vue&type=style&index=0&id=6635956d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6635956d",
  null
  
)

export default component.exports